import {
    FORM_ERROR,
    FORM_SUCCESS,
    FORM_RESET_AFTER,
} from 'store/mutation-types'

export default (store) => {
    const regex = /^(([a-z]+\d+)\/)?(FORM_[A-Z]+)$/,
        groups = {
            leftSide: 1,
            module: 2,
            mutation: 3
        }

    store.subscribe((mutation, state) => {
        const matches = regex.exec(mutation.type)

        if (_.isNull(matches))
            return

        // debugger
        /*
         This regex will match FORM_ERROR and FORM_SUCCESS
         but not FORM_UID_CHANGED
         */
        let shouldNotify = false,
            resourceForm = state.resourceForm,
            [title, type, message] = Array(3).fill(null),
            operationType = resourceForm.method === "put" ?
                "update" : resourceForm.method === "post" ?
                    "store" : resourceForm.method === "delete" ?
                        resourceForm.method : null

        if (_.isNull(operationType))
            return

        const isModule = !_.isNil(matches[groups.module]),
            finalType = matches[groups.mutation],
            isFormSuccess = finalType === FORM_SUCCESS,
            verifyState = () => {
                const formError = isModule ?
                    state.formError : state[matches[groups.module]].formError
                return !_.isEmpty(formError)
            },
            isFormError = finalType === FORM_ERROR && verifyState()
        // debugger
        title = resourceForm.resource
        message = resourceForm.message[operationType]
        type = resourceForm.correspondingTypes

        if (isFormSuccess) {
            shouldNotify = true
            message = message.success
            type = type.success

        } else if (isFormError) {
            shouldNotify = true
            message = message.error
            type = type.error
        }

        if (shouldNotify) {
            $('body').pgNotification({
                style: "circle",
                title,
                type,
                message,
                timeout: 5000
            }).show()

            store.commit(FORM_RESET_AFTER)
        }
    })

}



// WEBPACK FOOTER //
// ./client/utils/form-response-notificator.js